import { Divider } from "@/components/ui/divider";
import Text from "@/components/ui/text";
import { cn } from "@/utils/utils";
import React from "react";

interface Props {
  isExpandedView: boolean;
  title: string;
  content: JSX.Element;
  expandedClassName?: string;
  hideDivider?: boolean;
  hideTitle?: boolean;
}

const ActivityDetailsSection: React.FC<Props> = ({
  isExpandedView,
  title,
  content,
  expandedClassName,
  hideDivider = false,
  hideTitle = false
}) => {
  return (
    <>
      {!isExpandedView && !hideDivider && <Divider />}
      <div
        className={cn(
          "flex flex-col gap-2",
          isExpandedView && "p-6",
          isExpandedView && expandedClassName
        )}
      >
        {!hideTitle && (
          <Text variant={isExpandedView ? "smSubtitle" : "lgLabel"}>
            {title}
          </Text>
        )}
        {content}
      </div>
    </>
  );
};

export default ActivityDetailsSection;
